// Inkesh Printer Configurator — live cart total + multi-line-item add to cart
// v4: Removed monthly payment calculation (price/12 was not accurate). Quote modal event dispatch retained.
(function() {
  document.querySelectorAll('[data-inkesh-config]').forEach(function(root) {
    var totalEl = root.querySelector('[data-config-total]');
    var barTotalEl = root.querySelector('[data-config-bar-total]');
    var imageEl = root.querySelector('[data-config-image]');
    var placeholderEl = root.querySelector('[data-config-image-placeholder]');
    var variantLabelEl = root.querySelector('[data-config-variant-label]');
    var cartBtn = root.querySelector('[data-config-add-to-cart]');
    var quoteBtn = root.querySelector('[data-config-quote]');
    var toast = root.querySelector('[data-config-toast]');
    var productTitle = root.dataset.productTitle || '';

    var currentModelVariantId = root.dataset.initialVariantId || '';
    var currentModelPrice = parseInt(root.dataset.initialPrice || '0', 10);
    var currentModelTitle = root.dataset.initialVariantTitle || '';
    var selectedAddons = {}; // { blockId: { variantId, price, name } }

    function formatMoney(cents) {
      var dollars = cents / 100;
      return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function recalcTotal() {
      var total = currentModelPrice;
      Object.keys(selectedAddons).forEach(function(k) { total += selectedAddons[k].price; });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (barTotalEl) barTotalEl.textContent = formatMoney(total);
    }

    function stripGid(id) {
      return String(id || '').replace('gid://shopify/ProductVariant/', '');
    }

    function swapImage(src) {
      if (!src || !imageEl) return;
      imageEl.src = src;
      imageEl.style.display = '';
      if (placeholderEl) placeholderEl.style.display = 'none';
    }

    function buildQuotePayload() {
      var items = [];
      items.push({
        name: productTitle + ' (' + currentModelTitle + ')',
        priceCents: currentModelPrice
      });
      Object.keys(selectedAddons).forEach(function(k) {
        var a = selectedAddons[k];
        items.push({ name: a.name, priceCents: a.price });
      });
      var total = currentModelPrice;
      Object.keys(selectedAddons).forEach(function(k) { total += selectedAddons[k].price; });
      return { items: items, totalCents: total, productTitle: productTitle };
    }

    // Model selector
    root.querySelectorAll('[data-config-card="model"]').forEach(function(card) {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        root.querySelectorAll('[data-config-card="model"]').forEach(function(c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var input = card.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        currentModelVariantId = card.dataset.variantId;
        currentModelPrice = parseInt(card.dataset.variantPrice, 10);
        currentModelTitle = card.dataset.variantTitle || '';
        if (card.dataset.variantImage) swapImage(card.dataset.variantImage);
        if (card.dataset.variantTitle && variantLabelEl) variantLabelEl.textContent = card.dataset.variantTitle;
        recalcTotal();
      });
    });

    // Add-on selectors
    root.querySelectorAll('[data-config-card="addon"]').forEach(function(card) {
      var group = card.dataset.addonGroup;
      var variantId = card.dataset.variantId;
      var price = parseInt(card.dataset.variantPrice || '0', 10) * 100; // dollars -> cents
      var name = card.dataset.addonName || '';

      card.addEventListener('click', function(e) {
        e.preventDefault();
        root.querySelectorAll('[data-addon-group="' + group + '"]').forEach(function(c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
        var input = card.querySelector('input[type="radio"]');
        if (input) input.checked = true;

        if (variantId && variantId !== '') {
          selectedAddons[group] = { variantId: stripGid(variantId), price: price, name: name };
        } else {
          delete selectedAddons[group];
        }
        recalcTotal();
      });
    });

    function showToast(msg, isError) {
      if (!toast) return;
      toast.textContent = msg;
      toast.style.background = isError ? '#d70015' : '#1d1d1f';
      toast.classList.add('is-visible');
      setTimeout(function() { toast.classList.remove('is-visible'); }, 2500);
    }

    if (quoteBtn) {
      quoteBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var payload = buildQuotePayload();
        document.dispatchEvent(new CustomEvent('inkesh:openQuoteModal', { detail: payload }));
      });
    }

    if (cartBtn) {
      cartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        cartBtn.disabled = true;
        var originalText = cartBtn.textContent;
        cartBtn.textContent = 'Adding...';

        var items = [{ id: parseInt(stripGid(currentModelVariantId), 10), quantity: 1 }];
        Object.keys(selectedAddons).forEach(function(k) {
          var a = selectedAddons[k];
          items.push({ id: parseInt(a.variantId, 10), quantity: 1 });
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function(res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        }).then(function() {
          showToast('Added to cart!');
          setTimeout(function() { window.location.href = '/cart'; }, 800);
        }).catch(function() {
          showToast('Could not add to cart. Please try again.', true);
          cartBtn.disabled = false;
          cartBtn.textContent = originalText;
        });
      });
    }

    recalcTotal();
  });
})();
